

































































































































































import Vue from 'vue'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { ProjectDetail } from '@/model/project/ProjectDetail'
import { ProjectDetailFooter } from '@/model/project/ProjectDetailFooter'
import { ProjectDetailHeader } from '@/model/project/ProjectDetailHeader'
import DxDataGrid from 'devextreme-vue/data-grid'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProjectDetailForm from '@/components/project/ProjectDetailForm.vue'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import ProjectAddressSearch from '@/components/master-data/address/ProjectAddressSearch.vue'
import { SET_PROJECT_LOCK_STATUS } from '@/store/action-types'
import { ResponseBase } from '@/types/service-response'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  formIsValid: boolean
  validationRules: Array<Function>
  address: string
  profitCenterBezeichnung: any | undefined
  prozess: any | undefined
  select2List: any
  projektNummer: string
  eingangVia: any | undefined
  select3List: any
  unsereReferenzVollerName: any | undefined
  select4List: any
  sachbearbeiter: any | undefined
  select5List: any
  titel: string
  ihreReferenz: string
  lieferkondition: any | undefined
  select6List: any
  zahlungskondition: any | undefined
  select7List: any
  versand: any | undefined
  select8List: any
  select9: any | undefined
  select9List: any
  select10: any | undefined
  select10List: any
  menu1: boolean
  menu2: boolean
  projectDate: string
  projectDateFormatted: string
  referenceDate: string
  referenceDateFormatted: string
  dateRules: any[]
  showSearchDialog: boolean

  erfassung: string
  netto: string
  steuer: string
  total: string

  gesperrt: boolean
  gesperrtVonName: string
}

export default Vue.extend({
  name: 'ProjectForm',

  components: {
    ProjectDetailForm,
    ProjectAddressSearch,
    DxDataGrid
  },

  props: {
    projectId: Number,
    projectDetail: Array as () => ProjectDetail[],
    projectDetailHeader: Object as () => ProjectDetailHeader,
    projectDetailFooter: Object as () => ProjectDetailFooter,
    isCreateProject: Boolean,
    isEditProject: Boolean,
    selectedProjectId: Number
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('project.required').toString()

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      formIsValid: false,
      validationRules: [required],
      address: '',
      profitCenterBezeichnung: '',
      prozess: undefined,
      select2List: [],
      projektNummer: '',
      eingangVia: undefined,
      select3List: [],
      unsereReferenzVollerName: undefined,
      select4List: [],
      sachbearbeiter: undefined,
      select5List: [],
      titel: '',
      ihreReferenz: '',
      lieferkondition: undefined,
      select6List: [],
      zahlungskondition: undefined,
      select7List: [],
      versand: undefined,
      select8List: [],
      select9: undefined,
      select9List: [],
      select10: undefined,
      select10List: [],
      menu1: false,
      menu2: false,
      projectDate: '',
      projectDateFormatted: '',
      referenceDate:'',
      referenceDateFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || 'Falsche Datum.' : true
        },

        (value: string) => {
          return value.length !== 10 ? 'Falsche Datum.' : true
        }
      ],
      showSearchDialog: false,

      erfassung: '',
      netto: '',
      steuer: '',
      total: '',

      gesperrt: false,
      gesperrtVonName: ''
    }
  },

  watch: {
    isCreateProject (newVal: boolean) : void {
      if(newVal) {
        this.setHeader()
        this.setFooter()
        const form: any = this.$refs['form']
        form.resetValidation()
      } else {
        this.setHeader(this.projectDetailHeader)
        this.setFooter(this.projectDetailFooter)
        const form: any = this.$refs['form']
        form.resetValidation()
      }
    },

    projectDetailHeader (newVal: ProjectDetailHeader): void {
      if(newVal) {
        this.setHeader(newVal)
      }
    },

    projectDetailFooter (newVal: ProjectDetailFooter): void {
      if(newVal) {
        this.setFooter(newVal)
      }
    },

    projectDateFormatted (newVal: string): void {
      if(newVal) {
        this.projectDate = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      }
    },

    referenceDateFormatted (newVal: string): void {
      if(newVal) {
        this.referenceDate = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEditMode (): boolean {
      return this.isCreateProject || this.isEditProject
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onSearchAddressClick (): void {
      this.showSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
    },

    onSelectedAddress (data: SearchAddress): void {
      this.showSearchDialog = false
      this.address = data.genAdresse
      //this.selectedAddressId = data.id
    },

    onProjectDateChange (date: string): void {
      this.projectDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onReferenceDateChange (date: string): void {
      this.referenceDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onFocusProject (): void {
      setTimeout(() => {
        if(!this.menu1) {
          this.menu1 = true
        }
      }, 100)
    },

    onBlurProject (): void {
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onFocusReference (): void {
      setTimeout(() => {
        if(!this.menu2) {
          this.menu2 = true
        }
      }, 100)
    },

    onBlurReference (): void {
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },


    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
      }
    },

    setHeader (data?: ProjectDetailHeader): void {
      this.address = data ? data.AdressFeld.replace(/\n/g, "<br />") : ''
      this.profitCenterBezeichnung = data ? data.ProfitCenterBezeichnung : ''
      this.prozess = data ? data.ProzessArtBezeichnung : undefined
      this.projektNummer = data ? data.Nummer : ''
      this.eingangVia = data ? data.EingangViaBzg : undefined
      this.unsereReferenzVollerName = data ? data.UnsereReferenzNameK : undefined
      this.sachbearbeiter = data ? data.SachbearbeiterNameK : undefined

      this.titel = data ? data.Titel : ''
      this.ihreReferenz = data ? data.IhreReferenz : ''
      this.lieferkondition = data ? data.LieferkonditionBezeichnung : undefined
      this.zahlungskondition = data ? data.ZahlungskonditionBezeichnung : undefined
      this.versand = data ? data.VersandartBezeichnung : undefined

      this.referenceDate = data ? moment(data.ReferenzTermin).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      this.referenceDateFormatted = data ? moment(data.ReferenzTermin).format('DD.MM.YYYY') : moment().format('DD.MM.YYYY')
      this.projectDate = data ? moment(data.ProjektDatum).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      this.projectDateFormatted = data ? moment(data.ProjektDatum).format('DD.MM.YYYY') : moment().format('DD.MM.YYYY')

      this.gesperrt = data && data.Gesperrt === 'True' ? true : false
      this.gesperrtVonName = data ? data.GesperrtVonNameK : ''
    },

    setFooter (data?: ProjectDetailFooter): void {
      this.erfassung = ''
      this.netto = data ? parseFloat(data.Netto.toString()).toFixed(2).toString() : ''
      this.steuer = data ? parseFloat(data.Steuer.toString()).toFixed(2).toString() : ''
      this.total = data ? parseFloat(data.Total.toString()).toFixed(2).toString() : ''
    },

    async onProjectLockStatusChange (item: boolean): Promise<void> {
      const payload: any = {
        projectId: this.projectId,
        value: item ? 1 : 0
      }

      try {
        const response: ResponseBase = await this.$store.dispatch(SET_PROJECT_LOCK_STATUS, payload)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.$emit('updateData')
      }
    },

    onCancelProjectHeaderClick (): void {
      this.$emit('onCancelProjectHeaderClick')
    },

    onSaveProjectHeaderClick (): void {
      if(this.isCreateProject) {
        this.$emit('onCreated', 0)
      } else if(this.isEditProject) {
        this.$emit('onEdited')
      }
    },

    createdDetail (): void {
      this.$emit('createdDetail')
    },

    updatedDetail (): void {
      this.$emit('updatedDetail')
    },

    deletedDetail(item: ProjectDetail): void {
      this.$emit('deletedDetail', item)
    }
  },

  mounted () {
    if(this.projectDetailHeader) {
      this.setHeader(this.projectDetailHeader)
    }
    if(this.projectDetailFooter) {
      this.setFooter(this.projectDetailFooter)
    }
  }
})
